import React from "react";
import PropTypes from "prop-types";
class HelloWorld extends React.Component {
  render() {
    return <React.Fragment>Greeting: {this.props.greeting}</React.Fragment>;
  }
}

HelloWorld.propTypes = {
  greeting: PropTypes.string,
};

export default HelloWorld;



// WEBPACK FOOTER //
// ./app/frontend/components/HelloWorld.js